import { format } from 'date-fns/fp';
import { camelCase, startCase } from 'lodash';

export const cstFormatter = new Intl.DateTimeFormat('en-US', {
  dateStyle: 'short',
  timeStyle: 'long',
  timeZone: 'america/chicago',
});

const moneyFormatter = new Intl.NumberFormat('en', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const percentFormatter = new Intl.NumberFormat('en', {
  style: 'percent',
  minimumFractionDigits: 2,
  minimumIntegerDigits: 2,
});
export const formatMoney = (value: number) => moneyFormatter.format(value);
export const formatPercent = (value: number) => percentFormatter.format(value);

export const formatDecimal = (value: number, minDecimalConfig: number, maxDecimalConfig: number) =>
  '$' +
  Intl.NumberFormat('en-US', {
    minimumFractionDigits: minDecimalConfig,
    maximumFractionDigits: maxDecimalConfig,
  }).format(value as number);

export const formatDate = format('MM-dd-yy');
export const formatSlashDate = format('MM/dd/yyyy');

export const formatHumanDateWithTime = format('MMM do yyyy hh:mm aaaa');
export const formatDateWithTime = format('MM/dd/yyyy hh:mm a');

export function byAlphaNumeric<T>(getter: (value: T) => string) {
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
  return (a: T, b: T) => collator.compare(getter(a), getter(b));
}

export function alphaNumericSort<T>(data: T[], getter: (value: T) => string) {
  return [...data].sort(byAlphaNumeric(getter));
}

export function toTitleCase(phrase: string) {
  return startCase(camelCase(phrase));
}
